module.exports = __webpack_public_path__ + "img/N660-1-EN.bf5c7145.png";